import { ErrorView, Icon, Layout, LoadingAnimation, Timeline, useElementSize } from '@uag/react-core';
import { useGetRequestById } from '@uag/welcome-shared/src/api/queries/requests/requests';
import { useGetSteps } from '@uag/welcome-shared/src/api/queries/steps/steps';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams, Link } from 'react-router';

import { orderBy } from 'shared/utils';
import { getVisibleSteps } from 'utils/getVisibleSteps';
import { Step } from './components/Step';

export const Request = () => {
    const { t } = useTranslation();
    const { requestId = '' } = useParams();
    const { ref, width } = useElementSize();
    const navigate = useNavigate();
    const layout = width < 800 && ref ? Layout.OneColumn : Layout.TwoColumns;

    const { data: steps, isLoading: areStepsLoading, error: stepsError } = useGetSteps(requestId);
    const { data: request, isLoading: isRequestLoading, isError: isRequestError } = useGetRequestById(requestId);

    useEffect(() => {
        if (isRequestError) {
            navigate('/requests/not-found-expired');
        }
    }, [isRequestError, navigate]);

    if (stepsError) {
        return <ErrorView description={t('errorLoadingSteps')} title={t('somethingWentWrong')} />;
    }

    return (
        <>
            <Link className="gap-sm text-text-accent flex text-base" to="/requests">
                <Icon icon="arrow_back" />
                <p>{t('back')}</p>
            </Link>
            <div className="mb-7">
                <h1 className="font-default leading-4xl text-text-default text-4xl font-semibold md:p-0 md:text-4xl">
                    {t('registerCompany')}
                </h1>
                <p className="font-base text-text-light text-base font-normal md:p-0">{t('enterYourData')}</p>
            </div>
            <div ref={ref} className="m-auto max-w-[1564px] pb-16">
                <Timeline className="m-2" layout={layout}>
                    {(areStepsLoading || isRequestLoading) && <LoadingAnimation />}
                    {steps
                        && steps.data
                        && request
                        && request.data
                        && orderBy(getVisibleSteps(steps.data), ['order']).map((step) => (
                            <Step key={step.order} request={request.data} step={step} />
                        ))}
                </Timeline>
            </div>
        </>
    );
};
